import {useNavigate} from "react-router-dom";

const data = [
    {
        title: "Practice Tracker",
        description: "Automatically reviews your responses to highlight trends, progress, and skill gaps.",
        image:"chart.svg",
        href:"/tools/practice-analysis/Wap"
    },{
        title: "CEFR Level Check",
        description: "Focused word collections designed to match real DET reading, listening, and speaking tasks.",
        image:"Vector.svg",
        href: "/tools/cefr-checker"
    },{
        title: "AI Score Breakdown",
        description: "AI-powered scoring highlights your strengths and weaknesses across grammar, complexity, vocabulary, and task relevance.",
        image:"Frame.svg",
    },{
        title: "Video Instruction Guides",
        description: "Short, clear videos that explain exactly how to approach each DET task with confidence.",
        image:"video.svg",
        href:"/guide/%F0%9F%93%BC%20Video%20Instructions"
    },{
        title: "Study Resources",
        description: "A collection of templates, sample answers, strategies, and skill-building lessons for all DET tasks.",
        image:"idea.svg",
        href:"/material"
    },{
        title: "Vocabulary Builder",
        description: "Focused word collections designed to match real DET reading, listening, and speaking tasks.",
        image:"Frame-1.svg",
        href:"/tools/vocabulary-list"
    }
]


export default function AdvanceLearning() {
    const navigate = useNavigate();
    return (
        <div className="px-[12px] bg-[#F9FAFB] lg:py-[140px] flex justify-center items-center box-border py-[18px] lg:px-[148px]">

            <div className={"flex flex-col gap-[20px] lg:gap-[82px]"}>
                <div className={"flex flex-col gap-[12px] lg:gap-[24px]"}>
                    <p className={"font-semibold text-[#0C98FE] text-[24px] lg:text-[48px] leading-[120%] lg:leading-[120%] text-center"}>
                      Advance <span className={"text-black"}> Learning </span>Tools
                    </p>
                    <p className={" text-[12px] lg:text-[18px] leading-[120%] lg:leading-[120%] text-center"}>
                        Get the guidance you need to learn smarter, stay organized, and improve consistently.                    </p>
                </div>

                <div className={"grid-cols-1 lg:grid-cols-3 gap-[24px] lg:gap-[24px] grid"}>
                    {
                        data.map((item, index) => (
                            <div
                                onClick={()=>{
                                    if(item.href){
                                        navigate(item.href)
                                    }
                                }}
                                key={index} className={`flex ${item.href ? "transition-transform shadow-md duration-300 cursor-pointer hover:scale-[1.05]" : ""} flex-col text-center border-[1px] gap-[12px] lg:gap-[16px] bg-white rounded-[8px] lg:rounded-[16px] p-[16px] lg:p-[24px] box-border`}>
                                <img src={`/advance-learning/${item.image}`} alt={item.title} className={"w-auto h-[48px] "}/>
                                <p className={"font-semibold text-[16px] lg:text-[20px] leading-[120%] lg:leading-[120%] text-black"}>
                                    {item.title}
                                </p>
                                <p className={" text-[12px] lg:text-[16px] leading-[120%] lg:leading-[120%] text-[#374151]"}>
                                    {item.description}
                                </p>
                            </div>
                        ))
                    }

                </div>
            </div>
        </div>
    );
}